export default {
  'oneParams': {
    'title': 'Account Opening Form (Individual Account)',
    'childrens': [
      {
        'title': 'Account Opening Form',
        'link': 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Personal-Account-Opening.pdf'
      },
      {
        'title': '(CRS-I (HK)) Individual Tax Residency Self-Certification Form',
        'link': 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/CRS-Individual-Tax-Self-Certification-Form.pdf'
      },
      {
        'title': 'Terms and Conditions of Business',
        'link': 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/EN/Business-Terms-and-Conditions.pdf'
      }
    ]
  },
  'twoParams': {
    'title': 'Account Opening Form - Corporate Account',
    'childrens': [
      {
        'title': 'Account Opening Form (Corporate Account)',
        'link': 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Company-Account-Opening-Form.pdf'
      },
      // {
      //   'title': 'Risk Approach Form - Corporate Client',
      //   'link': 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Risk-Assessment-Form.pdf'
      // },
      {
        'title': 'Entity Tax Residency Self-Certification Form(CRS-E (HK))',
        'link': 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Entity-Tax-Self-Certification-Form.pdf'
      },
      {
        'title': 'Controlling Person Tax Residency Self-Certification Form (CRS-CP (HK))',
        'link': 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Controlling-Person-Tax-Self-Certification-Form.pdf'
      },
      {
        'title': 'Terms and Conditions of Business',
        'link': 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/EN/Business-Terms-and-Conditions.pdf'
      }
    ]
  },
  'threeParams': {
    'title': 'Other Forms',
    'childrens': [
      {
        'title': 'Closure or Suspend of Trading Account',
        'link': 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Cancellation-of-authorization-of-account-authorization.pdf'
      },
      {
        'title': 'Change of Personal Particulars Form',
        'link': 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Account-Communication-Service-Form.pdf'
      },
      {
        'title': 'Withdrawal Form',
        'link': 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Aide-Withdrawal-Form.pdf'
      },
      {
        'title': 'Physical Securities Deposit Form',
        'link': 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Stock-Physical-Deposit-Form.pdf'
      },
      {
        'title': 'Physical Securities Withdrawal Form',
        'link': 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/TC/Stock-Withdrawal.pdf'
      },
      {
        'title': 'Risks of Structured Products Disclosure Statement',
        'link': 'http://download.eddidapp.com/pdf/TC/risks-of-structured-products-disclosure-statement.pdf'
      },
      {
        title: 'Internal Fund Transfer/Currency Exchange Request Form',
        link: 'https://download-hangzhou.oss-cn-hangzhou.aliyuncs.com/pdf/EN/IFTCERForm.pdf'
      }
    ]
  }
}
